import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

var Divider = (props)=>{
    const { className , orientation ='horizontal' , caption  } = props, rest = swcHelpers.objectWithoutProperties(props, [
        "className",
        "orientation",
        "caption"
    ]);
    /**
   * Vertical dividers are tricky, so we don't do anything special with them.
   */ if (orientation === 'vertical') {
        return /*#__PURE__*/ React.createElement(BareDivider, swcHelpers.extends({}, props));
    }
    if (!caption) {
        return /*#__PURE__*/ React.createElement(BareDivider, swcHelpers.extends({}, props));
    }
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('divider-wrapper', className)
    }), /*#__PURE__*/ React.createElement(BareDivider, swcHelpers.extends({}, props, {
        "aria-hidden": "true"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "divider__caption"
    }, caption), /*#__PURE__*/ React.createElement(BareDivider, swcHelpers.extends({}, props)));
};
function BareDivider(props) {
    const { className , orientation ='horizontal' , theme ='regular' , caption: _  } = props, rest = swcHelpers.objectWithoutProperties(props, [
        "className",
        "orientation",
        "theme",
        "caption"
    ]);
    return /*#__PURE__*/ React.createElement("hr", swcHelpers.extends({
        className: classnames('divider', `divider--${orientation}`, className, {
            'divider--light': theme === 'light'
        }),
        "aria-orientation": orientation,
        "aria-hidden": rest['aria-hidden']
    }, rest));
}

export { Divider };
//# sourceMappingURL=Divider.js.map
